import React from 'react';
import { FadeInContainer, FadeInDot } from './wrappers';
import clsx from 'clsx';

interface IFadeInDotIndicator {
  steps: number[];
  activeStep: number;
}

const FadeInDotIndicator = ({ steps, activeStep }: IFadeInDotIndicator) => {
  return (
    // TODO: Refactor logic for clsx and inline transform style

    // TranslateX in this case will make sure that the active step is in the middle exept for
    // the three first and last steps. For these we want the whole dotindicator to be in center
    <FadeInContainer
      className="hidden-md"
      style={{
        transform: `translateX(${
          activeStep === 0
            ? '-24'
            : activeStep === 1
              ? '-32'
              : activeStep === 2
                ? '-40'
                : activeStep === steps.length - 1
                  ? `-${activeStep * 16 - 24}`
                  : activeStep === steps.length - 2
                    ? `-${activeStep * 16 - 16}`
                    : activeStep === steps.length - 3
                      ? `-${activeStep * 16 - 8}`
                      : `-${activeStep * 16}`
        }px)`,
      }}>
      {steps &&
        steps.map((src, index) => (
          <FadeInDot
            key={src}
            className={clsx(
              src === activeStep && 'active',
              activeStep + 2 === index && 'medium',
              activeStep - 2 === index && 'medium',
              activeStep + 3 === index && 'small',
              activeStep - 3 === index && 'small',
              activeStep + 4 <= index && 'hidden-dot',
              activeStep - 4 >= index && 'hidden-dot',
            )}
          />
        ))}
    </FadeInContainer>
  );
};

export default FadeInDotIndicator;
